import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {LazyLoadEvent, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../cc-base.component';
import {TableColumnConfig} from "../../model/api/table-column-config";
import {TableRequest} from "../../model/api/table-request";
import {Table} from "primeng/table";
import {ExportAsService} from "ngx-export-as";
import * as XLSX from 'xlsx';
import {BookType} from 'xlsx';
import * as jsPDF from 'jspdf';
import {CctableBaseComponent} from "../table/cc-table-base.component";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'cc-readonly-table',
  templateUrl: './readonly-table.component.html',
  styleUrls: ['./readonly-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ]
})
export class ReadonlyTableComponent extends CctableBaseComponent {

  tableValueMap = {};

  constructor(el: ElementRef,
              cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              exportAsService: ExportAsService) {
    super(el, cdref, messageService, translateService, exportAsService);
  }

  public reloadTableValueMap() {
    this.tableConfig.forEach((conf, index) => {
      if (!conf.hidden && this.ccTable && this.ccTable.processedData) {
        this.ccTable.processedData.forEach((record, recordIndex) => {
          const trueRecordIndex = recordIndex + this.ccTable.first;
          if (record) {
            if (conf.style)
              this.tableValueMap['style-' + index + '_' + trueRecordIndex] = conf.style(record);
            if (conf.mapId)
              this.tableValueMap['mapId-' + index + '_' + trueRecordIndex] = conf.mapId(record);
            if (conf.class)
              this.tableValueMap['class-' + index + '_' + trueRecordIndex] = conf.class(record);
            if (conf.icon)
              this.tableValueMap['icon-' + index + '_' + trueRecordIndex] = conf.icon(record);
            if (conf.iconValue)
              this.tableValueMap['iconValue-' + index + '_' + trueRecordIndex] = conf.iconValue(record);
            if (conf.toolTip)
              this.tableValueMap['toolTip-' + index + '_' + trueRecordIndex] = conf.toolTip(record);
          }
        })
      }
    });
    super.reloadTableValueMap();
  }
}
